export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20illustration%20with%20dark%20moody%20atmosphere%2C%20warm%20deep%20crimson%20and%20charcoal%20color%20palette%2C%20abstract%20geometric%20shapes%20suggesting%20information%20flow%20and%20breaking%20news%2C%20modern%20digital%20media%20aesthetic%2C%20stylized%20composition%20with%20negative%20space%20for%20text%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20editorial%20design%20quality%2C%20high%20contrast%2C%20no%20text%20or%20letters&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="黑料爆料平台主视觉"
          className="w-full h-full object-cover object-top"
          onError={(e) => {
            const t = e.currentTarget;
            t.style.display = 'none';
            if (t.parentElement) t.parentElement.style.backgroundColor = 'oklch(0.16 0.05 25)';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 text-primary-200 text-xs md:text-sm font-medium mb-4 md:mb-5">
              <i className="ri-fire-line text-sm"></i>
              实时更新 · 独家爆料
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 leading-tight mb-3 md:mb-4">
              黑料爆料 —
              <span className="block md:inline"> 全网八卦吃瓜第一站</span>
            </h1>

            <p className="text-base md:text-lg text-background-200/90 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-2">
              一站聚合全网最新最全的热搜八卦、娱乐圈内幕与独家爆料，7×24小时实时追踪更新。
            </p>
            <p className="text-sm md:text-base text-background-300/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6 md:mb-7">
              从顶流塌房到综艺黑幕，从网红翻车到品牌风波，安全进入黑料爆料网官网首页，随时随地在线查看最新吃瓜内容。当前热门专题聚焦选秀节目潜规则大起底与多家MCN机构数据造假内幕。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7 md:mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">12,876+</div>
                <div className="text-xs text-background-300/70 mt-0.5">累计爆料</div>
              </div>
              <div className="w-px h-8 bg-background-400/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">日更200+</div>
                <div className="text-xs text-background-300/70 mt-0.5">实时更新</div>
              </div>
              <div className="w-px h-8 bg-background-400/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">百万用户</div>
                <div className="text-xs text-background-300/70 mt-0.5">信赖浏览</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即浏览热榜
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm rounded-lg border border-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                我要爆料投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative aspect-[4/3] rounded-xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20breaking%20news%20concept%20illustration%2C%20warm%20crimson%20and%20dark%20tones%2C%20abstract%20newspaper%20headlines%20floating%20in%20space%2C%20stylized%20magnifying%20glass%20and%20document%20silhouettes%2C%20digital%20information%20age%20aesthetic%2C%20modern%20editorial%20design%2C%20cinematic%20composition%2C%20dramatic%20contrast%2C%20texture%20and%20depth%2C%20no%20readable%20text&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="黑料爆料 - 全网八卦吃瓜第一站"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const t = e.currentTarget;
                  t.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}